/**
 * @file: 图纸渲染方位判断
 * @author: xiaolong.huang@dmall.com
 */

import Config from '../config/index';
import Utils from '../utils/util';

export function isFrontFace(): boolean {
    let face: number = getFaceValue();

    return face === 0;
}

export function isLeftFace(): boolean {
    let face: number = getFaceValue();

    return face === 1;
}

export function isRightFace(): boolean {
    let face: number = getFaceValue();

    return face === 2;
}

export function isBackFace(): boolean {
    let face: number = getFaceValue();

    return face === 3;
}

// 卧柜视角
export function isTopFace(): boolean {
    let face: number = getFaceValue();

    return face === 4;
}

function getFaceValue(): number {
    let face: any = Config.get({
        moduleName: 'base',
        key: 'renderFace'
    });

    return Utils.toNumberForce(face);
}
